const prefix = "shopping/addresses";

export const FETCH_ADDRESS_LIST = `${prefix}/FETCH_ADDRESS_LIST`;
export const FETCH_ADDRESS_LIST_START = `${prefix}/FETCH_ADDRESS_LIST_START`;
export const FETCH_ADDRESS_LIST_SUCCESS = `${prefix}/FETCH_ADDRESS_LIST_SUCCESS`;
export const FETCH_ADDRESS_LIST_FAIL = `${prefix}/FETCH_ADDRESS_LIST_FAIL`;

export const ADD_ADDRESS = `${prefix}/ADD_ADDRESS`;
export const ADD_ADDRESS_START = `${prefix}/ADD_ADDRESS_START`;
export const ADD_ADDRESS_SUCCESS = `${prefix}/ADD_ADDRESS_SUCCESS`;
export const ADD_ADDRESS_FAIL = `${prefix}/ADD_ADDRESS_FAIL`;

export const UPDATE_ADDRESS = `${prefix}/UPDATE_ADDRESS`;
export const UPDATE_ADDRESS_START = `${prefix}/UPDATE_ADDRESS_START`;
export const UPDATE_ADDRESS_SUCCESS = `${prefix}/UPDATE_ADDRESS_SUCCESS`;
export const UPDATE_ADDRESS_FAIL = `${prefix}/UPDATE_ADDRESS_FAIL`;

export const DELETE_ADDRESS = `${prefix}/DELETE_ADDRESS`;
export const DELETE_ADDRESS_START = `${prefix}/DELETE_ADDRESS_START`;
export const DELETE_ADDRESS_SUCCESS = `${prefix}/DELETE_ADDRESS_SUCCESS`;
export const DELETE_ADDRESS_FAIL = `${prefix}/DELETE_ADDRESS_FAIL`;

export const fetchAddressList = () => ({ type: FETCH_ADDRESS_LIST, meta: { thunk: true } });

export const addAddress = (address) => ({ type: ADD_ADDRESS, payload: address, meta: { thunk: true } });
export const updateAddress = (addressId) => ({ type: UPDATE_ADDRESS, payload: addressId, meta: { thunk: true } });
export const deleteAddress = (address) => ({ type: DELETE_ADDRESS, payload: address, meta: { thunk: true } });
